export default __webpack_public_path__ + "static/media/bg14.769b0e6f.jpeg";